module.exports = __webpack_public_path__ + "img/n2.d72cd253.png";